// extracted by mini-css-extract-plugin
export default {"contact":"contact_contact__4Ax5J","contact_title":"contact_contact_title__Y94fx","contact_item":"contact_contact_item__E0yph","link":"contact_link__PYAQ3"};